<template>
  <div class="bg-gray-100 min-h-screen p-4 sm:p-6 lg:p-8">
    <div class="max-w-7xl mx-auto">
      
      <header class="mb-8 text-center">
        <router-link to="/" class="inline-block">
          <img class="h-16 w-auto" src="@/assets/logo.png" alt="Castive Logo">
        </router-link>
      </header>

      <main>
        <h1 class="text-3xl font-bold text-gray-800 mb-6">All Guest Submissions</h1>

        <div class="bg-white shadow-md rounded-lg overflow-hidden">
          <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Guest Name</th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Submitted At</th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                  <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-if="loading">
                  <td colspan="5" class="px-6 py-4 text-center text-gray-500">Loading submissions...</td>
                </tr>
                <tr v-else-if="allSubmissions.length === 0">
                  <td colspan="5" class="px-6 py-4 text-center text-gray-500">No submissions found.</td>
                </tr>
                <tr v-else v-for="submission in allSubmissions" :key="submission.id">
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{{ submission.guestName }}</td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ submission.guestEmail }}</td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ formatDate(submission.submittedAt) }}</td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm capitalize">
                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                      :class="submission.status === 'completed' ? 'bg-status-completed-bg text-status-completed-text' : 'bg-status-pending-bg text-status-pending-text'">
                      {{ submission.status.replace(/_/g, ' ') }}
                    </span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <router-link :to="`/submission/${submission.id}`" class="text-brand-purple-dark hover:text-brand-pink-static">View / Sign</router-link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </main>

      <footer class="mt-12 text-center py-4">
         <div class="max-w-7xl mx-auto flex items-center justify-center space-x-2">
            <img src="@/assets/logo.png" alt="Castive Logo" class="h-6 w-auto opacity-75">
            <p class="text-sm text-gray-600 font-medium">Powered by Castive</p>
         </div>
      </footer>

    </div>
  </div>
</template>

<script>
import { db } from '@/firebase';
import { collection, query, onSnapshot, orderBy, where } from 'firebase/firestore';
import { mapState } from 'vuex';

export default {
  name: 'AllSubmissionsView',
  data() {
    return {
      allSubmissions: [],
      loading: true,
      unsubscribe: null,
    };
  },
  computed: {
    ...mapState(['clientId', 'authIsReady']) // --- RESTORED authIsReady ---
  },
  methods: { // --- REMOVED THE INCORRECT PERIOD ---
    formatDate(timestamp) {
      if (!timestamp || !timestamp.toDate) return 'N/A';
      const date = timestamp.toDate();
      const options = { day: 'numeric', month: 'short', year: 'numeric' };
      return new Intl.DateTimeFormat('en-GB', options).format(date);
    },
    fetchAllSubmissions() {
      if (!this.clientId) {
        this.loading = false;
        return;
      }

      const submissionsCollection = collection(db, 'submissions');
      const q = query(
        submissionsCollection, 
        where('clientId', '==', this.clientId),
        orderBy('createdAt', 'desc')
      );

      this.unsubscribe = onSnapshot(q, (snapshot) => {
        this.allSubmissions = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        this.loading = false;
      }, (error) => {
        console.error("Error fetching all submissions: ", error);
        this.loading = false;
      });
    }
  },
  watch: {
    authIsReady(isReady) { // --- RESTORED WATCHER ---
      if (isReady && !this.unsubscribe) {
        this.fetchAllSubmissions();
      }
    }
  },
  created() {
    if (this.authIsReady) {
      this.fetchAllSubmissions();
    }
  },
  beforeUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }
};
</script>